import i18n from '../../../i18n'

import { EntityActionTypeSelectOptionValue } from './EntityActionTypeSelect.constants'

export function getEntityActionTypeSelectOptions() {
  return {
    [EntityActionTypeSelectOptionValue.Add]: {
      label: i18n.t('Common.EntityActionTypeSelectAddNewOptionLabelKey'),
      value: EntityActionTypeSelectOptionValue.Add,
    },
    [EntityActionTypeSelectOptionValue.Edit]: {
      label: i18n.t('Common.EntityActionTypeSelectEditOptionLabelKey'),
      value: EntityActionTypeSelectOptionValue.Edit,
    },
    [EntityActionTypeSelectOptionValue.RemoveAll]: {
      label: i18n.t('Common.EntityActionTypeSelectRemoveAllOptionLabelKey'),
      value: EntityActionTypeSelectOptionValue.RemoveAll,
    },
  }
}

export function getEntityActionTypeSelectOptionsEditOnly() {
  return [
    {
      label: i18n.t('Common.EntityActionTypeSelectEditOptionLabelKey'),
      value: EntityActionTypeSelectOptionValue.Edit,
    },
  ]
}

export function isAddEntityActionType(option) {
  return option.value === EntityActionTypeSelectOptionValue.Add
}

export function isEditEntityActionType(option) {
  return option.value === EntityActionTypeSelectOptionValue.Edit
}

export function isRemoveAllEntityActionType(option) {
  return option.value === EntityActionTypeSelectOptionValue.RemoveAll
}
